import { useEffect } from "react";
import { useGuestBrand } from "@/lib/guestBrand";
import { derivePalette } from "@/lib/propertyTheme";

/**
 * Applies the property's palette to every guest surface.
 *
 * The lux variables live on `.lux-scope`, and there are several of those, so
 * the override ships as one injected rule with higher specificity
 * (`body.prop-tinted .lux-scope`) rather than being sprinkled inline.
 */
const STYLE_ID = "prop-theme";

export function PropertyTheme() {
  const { branding, hotelName } = useGuestBrand();

  useEffect(() => {
    const palette = derivePalette(branding);
    const existing = document.getElementById(STYLE_ID);

    if (!palette) {
      existing?.remove();
      document.body.classList.remove("prop-tinted");
      return;
    }

    const decl = Object.entries(palette)
      .map(([k, v]) => `  ${k}: ${v};`).join("\n");
    const css = `body.prop-tinted .lux-scope {\n${decl}\n}`;
    const tag = existing || Object.assign(document.createElement("style"), { id: STYLE_ID });
    tag.textContent = css;
    if (!existing) document.head.appendChild(tag);
    document.body.classList.add("prop-tinted");
    if (hotelName) document.body.dataset.propertyTheme = hotelName;
  }, [branding, hotelName]);

  return null;
}

export default PropertyTheme;
